/**
 * Purchasable Items API Client
 *
 * API client functions for purchasable item management endpoints.
 * Extends BaseApiClient for authentication, error handling, and type-safe requests.
 */

import type { PurchasableItem } from '@/types/purchase.types';

import { BaseApiClient } from './baseApiClient';

// ============================================================================
// Request / Response Types
// ============================================================================

export interface CreateItemRequest {
  name: string;
  description?: string;
  baseRateUsd: number;
}

export interface UpdateItemRequest {
  name: string;
  description?: string;
  baseRateUsd: number;
  version: number;
}

interface ListItemsResponse {
  items: PurchasableItem[];
  total: number;
}

// ============================================================================
// API Client
// ============================================================================

class ItemsApiClient extends BaseApiClient {
  listItems(appId: string): Promise<ListItemsResponse> {
    return this.get<ListItemsResponse>(`/applications/${appId}/items`);
  }

  getItem(appId: string, itemId: string): Promise<PurchasableItem> {
    return this.get<PurchasableItem>(`/applications/${appId}/items/${itemId}`);
  }

  createItem(appId: string, data: CreateItemRequest): Promise<PurchasableItem> {
    return this.post<PurchasableItem>(`/applications/${appId}/items`, data);
  }

  updateItem(appId: string, itemId: string, data: UpdateItemRequest): Promise<PurchasableItem> {
    return this.put<PurchasableItem>(`/applications/${appId}/items/${itemId}`, data);
  }
}

export const itemsApi = new ItemsApiClient();
